import { Link } from "react-router-dom";
import { Reveal, SectionHeading } from "@/components/site/Reveal";
import { WHY } from "@/lib/site";

export const WhyList = ({ items = WHY, bg = "bg-[var(--navy)]" }) => (
  <ol className="grid gap-px bg-white/10 border-y border-white/10 sm:grid-cols-2 lg:grid-cols-3">
    {items.map((w, i) => (
      <li key={w.title} className={bg}>
        <Reveal delay={(i % 3) * 0.08} className="group h-full p-7 sm:p-9 transition-colors duration-500 hover:bg-white/[0.04]">
          <span className="font-display text-sm text-[var(--green-bright)]">0{i + 1}</span>
          <h3 className="mt-6 font-display text-2xl font-semibold tracking-tight text-white" data-testid={`why-item-${i + 1}`}>{w.title}</h3>
          <p className="mt-3 text-slate-300 leading-relaxed">{w.text}</p>
        </Reveal>
      </li>
    ))}
  </ol>
);

export const WhySnapshot = () => (
  <section className="bg-[var(--navy)] grain relative py-20 md:py-28" data-testid="home-why">
    <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
      <div className="grid gap-8 md:grid-cols-12 md:items-end mb-14">
        <SectionHeading light className="md:col-span-8" eyebrow="Why choose us"
          title="Straightforward, friendly help from people who care about your home." />
        <Reveal delay={0.1} className="md:col-span-4 md:text-right">
          <Link to="/why-choose-us" data-testid="home-why-link" className="link-underline font-semibold text-white">More about how we work →</Link>
        </Reveal>
      </div>
      <WhyList />
    </div>
  </section>
);
